import { atom } from 'recoil'
import { TopicTypes } from 'services'

export const topicsList = atom<TopicTypes[]>({
  key: 'topicsList',
  default: []
})
